// Phase 1C — pure routing helper. Extracted so tests can import it without
// pulling GridViewer.tsx (React JSX) into a Node-environment test file.
export function routeFrom(hash: string): "grid" | "auth" {
  return hash.replace(/^#/, "") === "auth" ? "auth" : "grid";
}
